/**
 * Leesbare labels voor de stadium-kolommen van de drie entiteiten die ze hebben.
 *
 * Aanleiding (T1.1): de command-palette toonde `project.stage`, `lead.stage` en
 * `charging_locations.stage` ruw — dus `verkennen`, `new`, `voorlopig_ontwerp`.
 * Bij projecten viel dat niet op zolang de waarden toevallig al leesbaar waren;
 * na migratie 030 blijft het lelijk en bij leads stond er sowieso Engels in een
 * Nederlandse UI.
 *
 * Projecten hebben hun eigen bron met kleuren erbij: gebruik daarvoor
 * `getStageConfig` uit `components/crm/project/projectUtils`, niet dit bestand.
 */

import { stadiumLabel } from './chargingStages';

/** snake_case naar een leesbare zin: `voorlopig_ontwerp` -> `Voorlopig ontwerp`. */
export function formatStageLabel(stage: string | null | undefined): string {
  if (!stage) return 'Onbekend';
  const woorden = stage.replace(/_/g, ' ').trim();
  return woorden.charAt(0).toUpperCase() + woorden.slice(1);
}

/**
 * Leads dragen Engelse waarden in de database (zie `Lead` in types/crm.ts).
 * Die zijn niet te vertalen met een generieke opmaakregel, dus expliciet.
 */
const LEAD_STAGE_LABELS: Record<string, string> = {
  new: 'Nieuw',
  contacted: 'Gecontacteerd',
  qualified: 'Gekwalificeerd',
  proposal: 'Voorstel',
  negotiation: 'Onderhandeling',
  won: 'Gewonnen',
  lost: 'Verloren',
};

export function getLeadStageLabel(stage: string | null | undefined): string {
  if (!stage) return 'Onbekend';
  return LEAD_STAGE_LABELS[stage] ?? formatStageLabel(stage);
}

/**
 * Kavels (`charging_locations`) houden hun elf stadia — besluit 5 in de roadmap.
 *
 * Sinds T2.5 staat die lijst mét labels in `lib/chargingStages.ts`, en verwijst
 * deze functie daarheen in plaats van de snake_case zelf op te maken. De
 * uitkomst is voor alle elf stadia dezelfde als voorheen; het verschil is dat
 * er nog maar één plek is waar een label kan veranderen.
 */
export function getChargingStageLabel(stage: string | null | undefined): string {
  return stadiumLabel(stage);
}
